export default __webpack_public_path__ + "static/media/likeActive.2ab53e66.svg";